<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-double-right`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M25.902 23.298L14.015 11.224a1 1 0 00-1.32-.094l-.105.094-1.4 1.421a1 1 0 000 1.403L20.989 24l-9.797 9.952a1 1 0 000 1.403l1.399 1.421a1 1 0 001.319.094l.106-.094 11.887-12.075a1 1 0 000-1.403zm9.907 0L23.923 11.224a1 1 0 00-1.32-.094l-.106.094-1.399 1.421a1 1 0 000 1.403L30.895 24l-9.797 9.952a1 1 0 000 1.403l1.4 1.421a1 1 0 001.319.094l.105-.094L35.81 24.701a1 1 0 000-1.403z"/></svg>
</template>
<script>

export default {
  name: 'IconDoubleRight',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
